import Datepicker from 'vanillajs-datepicker/Datepicker';
import es from '../../../node_modules/vanillajs-datepicker/js/i18n/locales/es.js';
import el from '../../../node_modules/vanillajs-datepicker/js/i18n/locales/el.js';

import { language } from '../utils/language';

const createDate = ({ days, months, years }) => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  date.setMonth(date.getMonth() + months);
  date.setFullYear(date.getFullYear() + years);
  return date;
};

const date18YearsAgo = createDate({ days: 0, months: 0, years: -18 });

export const defaultDatepickerOptions = {
  // format date as DD/MM/YYYY
  format: 'dd/mm/yyyy',
  // allows to select dates that are only over 18 years
  maxDate: date18YearsAgo,
  language: language,
  autohide: true,
  orientation: 'bottom',
  buttonClass: 'datepicker__button',
  nextArrow: '',
  prevArrow: '',
};

const languages = [es, el];

const createInitializeDatepicker = () => {
  // adds additional languages support
  Object.assign(Datepicker.locales, ...languages);
  return (element, options = defaultDatepickerOptions) =>
    new Datepicker(element, options);
};

export const initializeDatepicker = createInitializeDatepicker();
